<script lang="ts" setup>
import { computed } from "vue";
import { useAuthStore } from "@/stores/auth.store";
import { useContextStore } from "@/stores/context.store";
import router from "@/router";

const authStore = useAuthStore();
const contextStore = useContextStore();

const currentUser = computed(() => contextStore.currentUser);
const fallbackUser = computed(() => authStore.userInfo);

const displayName = computed(() => {
  const firstName = currentUser.value?.firstName || "";
  const lastName = currentUser.value?.lastName || "";
  const fullName = [firstName, lastName].filter(Boolean).join(" ").trim();

  return fullName || currentUser.value?.email || fallbackUser.value?.email || "User";
});

const displayEmail = computed(() => {
  return currentUser.value?.email || fallbackUser.value?.email || "";
});

const initials = computed(() => {
  const firstName = currentUser.value?.firstName || "";
  const lastName = currentUser.value?.lastName || "";

  if (firstName || lastName) {
    return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
  }

  return displayEmail.value.slice(0, 2).toUpperCase() || "U";
});

const roleLabel = computed(() => {
  switch (currentUser.value?.role) {
    case "caravel_admin":
      return "Admin";
    case "operator_admin":
      return "Operator Admin";
    case "case_manager":
      return contextStore.moduleEnabled("orders") && !contextStore.moduleEnabled("copay")
        ? "Operator"
        : "Account Manager";
    default:
      return "User";
  }
});

const logout = () => {
  authStore.logout();
  router.push("/");
};
</script>

<template>
  <v-menu width="230" location="bottom end" offset="8">
    <template v-slot:activator="{ props }">
      <button type="button" v-bind="props" class="caravel-topbar-profile">
        <span class="caravel-topbar-profile__avatar">
          {{ initials }}
        </span>

        <span class="caravel-topbar-profile__text">
          <span class="caravel-topbar-profile__name">{{ displayName }}</span>
          <span class="caravel-topbar-profile__role">{{ roleLabel }}</span>
        </span>

        <i class="ph ph-caret-down caravel-topbar-profile__caret"></i>
      </button>
    </template>

    <v-list density="compact" :lines="false" class="profile-list" nav>
      <v-list-item class="dropdown-item" disabled>
        <div class="caravel-topbar-profile__menu-user">
          <strong>{{ displayName }}</strong>
          <span>{{ displayEmail }}</span>
        </div>
      </v-list-item>

      <v-divider class="my-1" />

      <v-list-item class="dropdown-item" @click="logout">
        <i class="mdi mdi-logout text-muted" />
        <span class="align-middle" data-key="t-logout">Logout</span>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
